<template>
  <div class="content-7__linkbox">
    <div
      v-for="block in trendTabbarList"
      :key="block.value"
      class="content-7__linkbox__item"
    >
      <div class="linkgroup">
        <div class="linkgroup__title">
          <span class="linkgroup__title__text">{{ block.label }}</span>
        </div>
        <div class="linkgroup__content">
          <a
            v-for="tab in block.list"
            :key="tab.value"
            class="button-primary"
            :class="{'active': currentRuleChosen === tab.value}"
            @click="chooseRule(tab)"
          >
            <span class="button-primary__text">{{ tab.label }}</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { webTrendTabbarMapping } from '@/utils/tabbarMapping'
export default {
  name: 'WebTrendTabbar',
  data() {
    return {
      trendTabbarList: {},
      lotteryType: '',
      currentRuleChosen: '',
      trendType: this.$route.query.trendType || ''
    }
  },
  watch: {
    $route: {
      deep: true,
      handler(route) {
        if (this.$route.query.trendType === 'LiShihKaiJiang') {
          this.chooseRule({
            label: '历史开奖',
            value: 'LiShihKaiJiang',
            link(lotteryCode) {
              return `/lottery/trend/${lotteryCode}?trendType=LiShihKaiJiang`
            }
          })
        } else if (this.currentRuleChosen !== route.query.trendType) {
          this.currentRuleChosen = route.query.trendType
          this.trendTabbarList.forEach(block => {
            block.list.forEach(tab => {
              if (tab.value === route.query.trendType) {
                this.chooseRule(tab)
              }
            })
          })
        }
      }
    }
  },
  created() {
    this.init()
  },
  methods: {
    async init() {
      const lotteryCode = this.$route.params.lottery_code
      this.lotteryType = await this.$getLotteryType(lotteryCode)

      // 特殊處理...
      switch (lotteryCode) {
        case 'fckl8':
        case 'fcxy28':
          // 2020/11: 這兩個彩種的頻率變了，所以和其他快樂8或幸運28要呈現的走勢圖表項目會不一樣
          this.trendTabbarList = webTrendTabbarMapping['others'].slice().map((item) => Object.assign({}, item))
          break
        default:
          // 避免修改到同一個記憶體位子的複製
          this.trendTabbarList = webTrendTabbarMapping[this.lotteryType].slice().map((item) => Object.assign({}, item))
      }

      if (!this.trendTabbarList) {
        console.warn('TrendTabbar: webTrendTabbarMapping 失敗!', webTrendTabbarMapping, this.lotteryType)
        return
      }
      if (this.trendType !== '') {
        this.currentRuleChosen = this.trendType
      } else {
        this.currentRuleChosen = this.trendTabbarList[0]['list'][0].value
      }
      this.$emit('change-component', this.currentRuleChosen)
    },
    chooseRule(item) {
      const lotteryCode = this.$route.params.lottery_code
      switch (item.value) {
        // 兩面推薦
        case 'LiangMianTueiJian':
          this.$router.push(`/lmTj/${lotteryCode}`)
          return

        // 專家推薦
        case 'JhuanJiaTueiJian':
          this.$router.push(`/expert/${lotteryCode}`)
          return

        // 購彩計畫
        case 'GouTsaiJiHua':
          this.$router.push(`/buyPlan/${lotteryCode}`)
          return

        // 殺號計畫
        case 'ShaHaoJiHua':
          this.$router.push(`/shJh/${lotteryCode}`)
          return
      }

      this.currentRuleChosen = item.value
      this.$emit('change-component', this.currentRuleChosen)
    }
  }
}
</script>
